import _t from 'DOC_ROOT/web/assets/euadmin/src/js/modules/translations';

const waitForCaptcha = (formSelector) => {
    window.onCaptchaSuccess = () => {
        const form = document.querySelector(formSelector);
        const loadingButtons = form.querySelectorAll('.loading-btn');
        for (let i = 0; i < loadingButtons.length; i += 1) {
            const loadingButton = loadingButtons[i];
            loadingButton.disabled = false;
            loadingButton.querySelector('.spinner-border').style.display = 'none';
            loadingButton.querySelector('.loading').style.display = 'none';
            loadingButton.querySelector('.loaded').style.display = 'inline';
        }
    };
    window.onCaptchaError = () => {
        // eslint-disable-next-line no-alert
        alert(_t('Captcha failed. Please try again.'));
    };
};

export default waitForCaptcha;
